import RoundedButton from "src/components/RoundedButton";
import { ShareDownloadDataType, useShareDownload } from "src/components/ShareMenu";
import IconDownloadPhoto from "src/icons/IconDownloadPhoto";

const RecapAssetShareDownload = ({
	data,
	hasInstagramShare,
}: {
	data: ShareDownloadDataType;
	hasInstagramShare: boolean;
}) => {
	const { handlePress, loading } = useShareDownload();

	return (
		<RoundedButton
			colorVariant={hasInstagramShare ? "Hollow" : "Contrast"}
			sizeVariant="Large"
			Icon={IconDownloadPhoto}
			onPress={() => handlePress(data)}
			loading={loading}
		>
			Save to device
		</RoundedButton>
	);
};
export default RecapAssetShareDownload;
